import React, { Component } from 'react';
import '../css/project.scss';

import Fade from 'react-reveal/Fade';

import { TweenMax } from 'gsap';

import { Link } from 'react-router-dom';

class PrjListCmp extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            isOpen: false,
            isScroll: false,
            scWid: ''
        }

        this.body = document.getElementsByTagName('body')[0];
    }
 

    componentDidMount(){

        let root = document.getElementById('root');
        let winWid = window.innerWidth;
        let rootWid = root.clientWidth;
        let scrollWid = winWid - rootWid;
        let isScroll = winWid > rootWid;

        // console.log(winWid, rootWid, scrollWid);


        /*
            기존 컨텐츠에 스크롤이 있는지 판단하여 레이어 오픈시 패딩추가
            닫을때 다시 패딩삭제하여 화면 흔들림방지
        */

        // 스크롤이 있는지 판단
        if(isScroll){
            this.setState({
                isScroll: true
            })
        }

        // 스크롤 너비를 state에 저장, 뷰 오픈/클로징시 값을 받아오기 위함
        this.setState({
            scWid: scrollWid
        });
    }


    // openView
    clickCheck = () => {
        // console.log('click!', this.props.type, this.props.idx);
        this.setState({
            isOpen : true
        });
        // this.body.classList.add('hide_sc');
        // if(this.state.isScroll){
        //     this.body.style.paddingRight = this.state.scWid+'px';
        // }
    }

    // closeView
    closeView = () => {

        //사라질때 모션 적용
        let hideSpeed = 300;
        let view = document.getElementsByClassName('item_view');
        TweenMax.to(view, hideSpeed/1000, 
            {
                opacity: 0,
                display: 'none'
            }
        );


        // 모션이 끝나고 사리지기
        setTimeout(
            () => {
                this.setState({
                    isOpen : !this.state.isOpen
                });
                this.body.classList.remove('hide_sc');
                if(this.state.isScroll){
                    this.body.style.paddingRight = 0;
                }
            }, hideSpeed
        )
    }


    render(){        
        return (
            <React.Fragment>
                    {/* <div className="item_card"> */}
                    <div className="item_card">

                        {/* 
                            React Reveal 적용 위치 주의 
                            item_card가 아닌 하위 엘리먼트에 적용
                            뷰페이지 뜰때 레이아웃 깨짐 방지
                        */}
                        <Fade bottom>

                            <div className="card">
                                <div className="img">
                                    <img src={this.props.img}/>
                                </div>
                                <div className="cont">
                                    <p className="type">
                                        {this.props.type}
                                    </p>
                                    <p className="title">
                                        {this.props.title}
                                    </p>
                                </div>
                            </div>

                        </Fade>

                        {/* view */}
                        {/* 
                            props 설정
                            닫기 클릭시 isOpen false 
                        */}
                        {/* {this.state.isOpen ? 
                            <PrjTopCmp 
                                type={this.props.type} 
                                title={this.props.title} 
                                img={this.props.img} 
                                closeView={this.closeView} 
                            />
                            :
                            null
                        } */}

                    </div>
            </React.Fragment>
        )
    }
}

export default PrjListCmp;